import React, { useState } from "react";
import ApplicationPopup from "../Popups/ApplicationPopup";
import AgentHelpPopup from "../Popups/AgentHelpPopup";
import CertContact from "../Popups/CertContact";


const UsefulLinks = () => {

    return (
        <>
            <a className="buy" href="/Category/Details/">Купить</a>
            <a className="sell" href="/TradeCreation/AddTrade">Продать</a>
            <ApplicationPopup note={"Помощь в торгах"}>
                <a className="torgHelp">Помощь <br /> в торгах</a>
            </ApplicationPopup>
            <a className="link link2" href="https://uc-itcom.ru/order-partner?partner=mitra_oyr" id="getCert">Выпуск и Продление ЭЦП</a>
            <AgentHelpPopup note={"Продвижение"}>
                <a className="promotion">Продвижение</a>
            </AgentHelpPopup>
        </>
    )
}

export default UsefulLinks;